import React, { createContext, useContext, useState, useEffect } from 'react';

const InvoiceFilterContext = createContext();

export const useFilter = () => useContext(InvoiceFilterContext);

export const InvoiceFilterProvider = ({ children }) => {
    const [filters, setFilters] = useState({
        sortFilter: 'invoiceDate',
        pastDueOnly: false,
        dateRange: '30',
        numberFilter: '',
        page:1
    });

    const updateFilter = (key, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [key]: value,
        }));
    };

    const clearFilters = () => {
        setFilters({
            sortFilter: 'invoiceDate',
            pastDueOnly: false,
            dateRange: '30',
            numberFilter: '',
            page: 1
        });
    };

    return (
        <InvoiceFilterContext.Provider value={{ filters, updateFilter, clearFilters }}>
            {children}
        </InvoiceFilterContext.Provider>
    );
};